module.exports = __webpack_public_path__ + "static/img/videos.07ae7d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/common/imgs/videos.jpg
// module id = 9LSR
// module chunks = 1